import Cookie from '@nuxt-common/util/app/utils/cookie/Cookie.js';
import { getCustomerState } from '#utils/CustomerState';
import { getError, getErrorMessage } from '#utils/ErrorHandler';
import { processErrorDetails } from '#utils/errorArrayDetails';
import { defineStore } from 'pinia';
import $http from '@vue-util/http';

const WISHLIST_ENDPOINT = '/xapi/wishlist/v1/lists';

export const useGetSelectedListStore = defineStore('getSelectedList', {
  state: () => ({
    selectedListOfUser: {},
    userSelectedListsError: null,
    userSelectedListsErrorDetails: null,
    selectedListLoadingState: false,
    selectedListErrorStatus: false,
  }),
  actions: {
    async getSpecificList({ listGuid, sortBy, sortOrder, filterBy, headers }) {
      this.selectedListLoadingState = true;
      this.selectedListErrorStatus = false;
      this.userSelectedListsError = null;
      this.userSelectedListsErrorDetails = null;
      try {
        const customerState = getCustomerState();
        let url = `${WISHLIST_ENDPOINT}/${listGuid}?expand=items,userInfo`;
        if (sortBy) url += `&sortBy=${sortBy}`;
        if (sortOrder) url += `&sortOrder=${sortOrder}`;
        if (filterBy) url += `&filter=${filterBy}`;
        url += `&_customerState=${customerState}`;
        const response = await $http.get(url, {
          headers,
        });
        const responseData = response.data || response;
        if (!getError(responseData)) {
          const data = responseData?.CustomerList || {};
          this.selectedListOfUser = data;
        } else {
          const errorObj = getError(responseData);
          const errorDetails = processErrorDetails(errorObj);
          const errorMessage = getErrorMessage(responseData, 'GENERIC');
          this.userSelectedListsError = errorMessage;
          this.userSelectedListsErrorDetails = errorDetails;
          this.selectedListOfUser = {};
        }
      } catch (error) {
        if (error.response?.status === 401) {
          Cookie.set('SignedIn', '0');
          this.selectedListErrorStatus = true;
        }
        const errorObj = getError(error?.response?.data);
        const errorDetails = processErrorDetails(errorObj); // processErrorDetails can handle undefined
        const errorMessage = getErrorMessage(error, 'BAD_REQUEST');
        this.userSelectedListsError = errorMessage;
        this.userSelectedListsErrorDetails = errorDetails;
        this.selectedListOfUser = {};
      } finally {
        this.selectedListLoadingState = false;
      }
    },
    setSpecificList(lists) {
      this.selectedListOfUser = lists;
    },
    setSelectedListError(error) {
      this.userSelectedListsError = error;
    },
    setSelectedListErrorDetails(errorDetails) {
      this.userSelectedListsErrorDetails = errorDetails;
    },
    setSelectedListLoadingState(loadValue) {
      this.selectedListLoadingState = loadValue;
    },
    setSelectedListErrorStatus(error) {
      this.selectedListErrorStatus = error;
    },
    removeItemFromList(itemGuid) {
      const items = this.selectedListOfUser?.list?.[0]?.items;
      if (Array.isArray(items)) {
        this.selectedListOfUser.list[0].items = items.filter((item) => item.itemGuid !== itemGuid);
      }
    },
    updateWishlist({ name, searchable, defaultList }) {
      const list = this.selectedListOfUser?.list?.[0];
      if (list) {
        this.selectedListOfUser.list[0].name = name;
        this.selectedListOfUser.list[0].searchable = searchable;
        this.selectedListOfUser.list[0].defaultList = defaultList;
      }
    },
  },
});
